import { useMutation } from 'react-query';
import api from '../../../../libs/api';


const addForceSync = (relaticsConfigurationFolderId?: any) =>
    api.post(`/api/v2/AsiteRelaticsSync/TriggerRelaticsForceSync`, {
        safe: true,
        data: {relaticsConfigurationFolderId: relaticsConfigurationFolderId}
    });

const useAddForceSync = () => {
    const addForceSyncMutation = useMutation(
        (relaticsConfigurationFolderId: any) => {
            return addForceSync(relaticsConfigurationFolderId);
        }
    );
    return { addForceSyncMutation };
};

export default useAddForceSync;